import React from 'react';

const HamburgerMenu = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="floating-hamburger-menu" // This class will be styled in App.css
      aria-label="Toggle Menu"
    >
      <svg viewBox="0 0 100 80" width="24" height="24" fill="#333">
        <rect width="100" height="15" rx="8"></rect>
        <rect y="30" width="100" height="15" rx="8"></rect>
        <rect y="60" width="100" height="15" rx="8"></rect>
      </svg>
    </button>
  );
};

export default HamburgerMenu;
